/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.component';
import * as i2 from './components/anon/header.component.ngfactory';
import * as i3 from '../../app/components/anon/header.component';
import * as i4 from '../../app/services/auth/auth.service';
import * as i5 from '@angular/http';
import * as i6 from '../../app/pipes/title-case.pipe';
import * as i7 from '@angular/router';
import * as i8 from './components/anon/footer.component.ngfactory';
import * as i9 from '../../app/components/anon/footer.component';
import * as i10 from '../../app/services/lookups/lookup.service';
import * as i11 from '../../app/services/shared/localStorage.service';
import * as i12 from '../../app/components/shared/notification.component';
const styles_AppComponent:any[] = ([] as any[]);
export const RenderType_AppComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),19,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted((null as any),['\n  '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
      16,'div',[['class','container']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),1,'app-header',([] as any[]),(null as any),[[(null as any),
          'opacityChanged']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i1.AppComponent = _v.component;
        if (('opacityChanged' === en)) {
          const pd_0:any = ((<any>_co.onOpacityChanged($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_HeaderComponent_0,i2.RenderType_HeaderComponent)),i0.ɵdid(245760,(null as any),
      0,i3.HeaderComponent,[i4.AuthService,i0.Renderer,i5.Http,i6.TitleCasePipe],(null as any),
      {opacityChanged:'opacityChanged'}),(_l()(),i0.ɵted((null as any),['\n    '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),7,'div',[['class','row']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['\n      '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'div',[['class',
          'col-md-12']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵeld(16777216,(null as any),
          (null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),i0.ɵdid(212992,(null as any),
          0,i7.RouterOutlet,[i7.ChildrenOutletContexts,i0.ViewContainerRef,i0.ComponentFactoryResolver,
              [8,(null as any)],i0.ChangeDetectorRef],(null as any),(null as any)),
      (_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵted((null as any),['\n    '])),
      (_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'app-footer',([] as any[]),(null as any),(null as any),(null as any),i8.View_FooterComponent_0,
          i8.RenderType_FooterComponent)),i0.ɵdid(49152,(null as any),0,i9.FooterComponent,
          [i10.LookupService],(null as any),(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n  '])),(_l()(),i0.ɵted((null as any),['\n'])),(_l()(),i0.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    _ck(_v,5,0);
    _ck(_v,12,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'app-root',([] as any[]),
      (null as any),[['window','mousemove'],['window','scroll'],['window','beforeunload']],
      (_v,en,$event) => {
        var ad:boolean = true;
        if (('window:mousemove' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).refreshUserState()) !== false);
          ad = (pd_0 && ad);
        }
        if (('window:scroll' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,1).onWindowScroll()) !== false);
          ad = (pd_1 && ad);
        }
        if (('window:beforeunload' === en)) {
          const pd_2:any = ((<any>i0.ɵnov(_v,1).onBeforeUnload()) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },View_AppComponent_0,RenderType_AppComponent)),i0.ɵdid(4308992,(null as any),
      0,i1.AppComponent,[i7.Router,i11.LocalStorageService,i4.AuthService,i12.NotificationComponent],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AppComponentNgFactory:i0.ComponentFactory<i1.AppComponent> = i0.ɵccf('app-root',
    i1.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiYzovUHJvamVjdHMvWXVEUklWL1NlcnZpY2VzQVBJL1l1RHJpdi1TZXJ2aWNlc0FQSS9FbmZvcmNlbWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vYzovUHJvamVjdHMvWXVEUklWL1NlcnZpY2VzQVBJL1l1RHJpdi1TZXJ2aWNlc0FQSS9FbmZvcmNlbWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy9jOi9Qcm9qZWN0cy9ZdURSSVYvU2VydmljZXNBUEkvWXVEcml2LVNlcnZpY2VzQVBJL0VuZm9yY2VtZW50L3NyYy9hcHAvYXBwLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vYzovUHJvamVjdHMvWXVEUklWL1NlcnZpY2VzQVBJL1l1RHJpdi1TZXJ2aWNlc0FQSS9FbmZvcmNlbWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdj5cclxuICA8ZGl2IGNsYXNzPVwiY29udGFpbmVyXCI+XHJcbiAgICA8YXBwLWhlYWRlciAob3BhY2l0eUNoYW5nZWQpPVwib25PcGFjaXR5Q2hhbmdlZCgkZXZlbnQpXCI+PC9hcHAtaGVhZGVyPlxyXG4gICAgPGRpdiBjbGFzcz1cInJvd1wiPlxyXG4gICAgICA8ZGl2IGNsYXNzPVwiY29sLW1kLTEyXCI+XHJcbiAgICAgICAgPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PlxyXG4gICAgICA8L2Rpdj5cclxuICAgIDwvZGl2PlxyXG4gICAgPGFwcC1mb290ZXI+PC9hcHAtZm9vdGVyPlxyXG4gIDwvZGl2PlxyXG48L2Rpdj5cclxuIiwiPGFwcC1yb290PjwvYXBwLXJvb3Q+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBLHdFQUFLO2FBQUEsMEJBQ0g7TUFBQTtNQUFBLGdCQUF1QiwyQ0FDckI7TUFBQTtVQUFBO1FBQUE7UUFBQTtRQUFZO1VBQUE7VUFBQTtRQUFBO1FBQVo7TUFBQSxtRUFBQTtNQUFBO01BQUEsbUNBQXFFO01BQ3JFO1VBQUEsMERBQWlCO1VBQUEsZUFDZjtVQUFBO01BQXVCLCtDQUNyQjtVQUFBO1VBQUEsbURBQUE7VUFBQTtjQUFBO01BQStCLDZDQUMzQjtNQUNGLDJDQUNOO1VBQUE7dUNBQUEsVUFBQTtVQUFBLGlEQUF5QjtVQUFBLFdBQ3JCLHVDQUNGO1VBQUE7SUFSRjtJQUdJOzs7O29CQ0xSO01BQUE7TUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7TUFBQSx1REFBQTtNQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/$$_gendir/app/app.component.ngfactory.ts